import type { Model } from 'Types/model';

export const getSelectedModelByName = (models: Model[] | undefined, selectedModel: string): Model | undefined =>
	models?.find((model) => model.name === selectedModel);
